import "date-fns";
import React, { useState, useEffect } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import { es } from "date-fns/locale";

//usar forwardRef ?
interface DatePickerCustomProps {
  fullWidth?: boolean;
  onChange?: (date: Date | null) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  value?: Date | string | null;
  minDate?: Date | string;
  maxDate?: Date | string;
  className?: string;
  label?: React.ReactNode;
  id?: string;
  error?: boolean;
  onBlur?: () => void;
  reference?: React.Ref<HTMLInputElement>;
  readOnly?: boolean;
  required?: boolean;
  invalidDateMessage?: React.ReactNode;
  sx?: Record<string, any>;
}

const DatePickerCustom: React.FC<DatePickerCustomProps> = ({
  fullWidth,
  onChange,
  onKeyDown,
  value,
  minDate,
  maxDate,
  className,
  label,
  id,
  error,
  onBlur,
  reference,
  readOnly = false,
  required,
  invalidDateMessage,
  sx,
}) => {
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = useState(value);
  const [dateError, setDateError] = useState<unknown>(null);
  const [touched, setTouched] = useState(false);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    if (onChange) onChange(date);
  };

  const handleBlur = () => {
    setTouched(true);
    if (onBlur) onBlur();
  };

  useEffect(() => {
    setSelectedDate(value);
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
      <DatePicker
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        minDate={minDate as any}
        maxDate={maxDate as any}
        onError={(reason) => setDateError(reason)}
        renderInput={(params: any) => {
          const hasInvalidDate =
            Boolean(invalidDateMessage) && Boolean(dateError) && touched;
          return (
            <TextField
              {...params}
              variant="standard"
              fullWidth={fullWidth}
              margin="normal"
              id={id}
              error={error || hasInvalidDate}
              helperText={hasInvalidDate ? invalidDateMessage : undefined}
              onBlur={handleBlur}
              onKeyDown={onKeyDown}
              required={required}
              autoComplete="off"
              name={`datepicker-${id || "nohistory"}`}
              sx={{
                "& .MuiInputAdornment-root": {
                  marginRight: "15px",
                },
                ...sx,
              }}
              inputProps={{
                ...params.inputProps,
                autoComplete: "new-password",
                autoCorrect: "off",
                spellCheck: false,
                inputMode: "numeric",
                pattern: "\\d*",
                readOnly: readOnly,
              }}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePickerCustom;
